var map = {
	"./1.jpg": 71546,
	"./10.jpg": 79978,
	"./11.jpg": 62310,
	"./12.jpg": 74164,
	"./13.jpg": 18472,
	"./2.jpg": 26641,
	"./3.jpg": 8479,
	"./4.jpg": 1180,
	"./5.jpg": 95844,
	"./6.jpg": 15625,
	"./7.jpg": 88548,
	"./8.jpg": 56411,
	"./9.jpg": 90366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15580;